import MainApp from './components/MainApp';

export default MainApp;


// WEBPACK FOOTER //
// ./routes/app/index.js